import { API } from '@/models/core'

export class Game {
  constructor (key = null, contestKey = null, app = null, name = null, desc = null, matchKeys = []) {
    this.key = key
    this.app = app
    this.name = name
    this.desc = desc
    this.contest_key = contestKey
    this.match_keys = matchKeys
  }
  static createFromJson (raw) {
    let obj = new Game()
    obj = Object.assign(obj, raw)
    obj.key = obj.game.key
    obj.name = obj.game.name
    obj.desc = obj.game.desc
    for (let match of obj.matches) {
      obj.match_keys.push(match.match.key)
    }
    return obj
  }
  static createGame (postData) {
    postData.app = API.faKey
    let params = postData
    return API.instance().post(`/fantasy-app/${API.faKey}/add_contest_game/`, params).then((resp) => {
      return resp.data
    })
  }

  static editGame (postData) {
    postData.app = API.faKey
    let params = postData
    return API.instance().post(`/fantasy-app/${API.faKey}/edit-contest-game/`, params).then((resp) => {
      return resp.data
    })
  }

  static fetchGame (gamekey) {
    let params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/game/${gamekey}/preview/`, params).then((resp) => {
      return Game.createFromJson(resp.data.data)
    })
  }

  static validateMatch (sport, key, matchKey) {
    let params = {}
    return API.instance().get(`/fantasy-app/${API.faKey}/validate_match_key/?sport=${sport}&match_key=${matchKey}`, params).then((resp) => {
      return resp.data
    })
  }

  static AddUsers (payload) {
    let params = payload
    return API.instance().get(`/fantasy-app/${API.faKey}/simulate-game-user/?game_key=${payload.game_key}&users_count=${payload.users_count}`, params).then((resp) => {
      return resp.data.data
    })
  }

  static simulateMatch (key) {
    let params = {
      'game': key,
      'sleep_time': 0.5
    }
    return API.instance().post(`/fantasy-app/${API.faKey}/simulate-game/`, params).then((resp) => {
      return resp.data
    })
  }

  static publishLeaderboard (key) {
    let payload = {
      'key': key
    }
    let params = payload
    return API.instance().post(`/fantasy-app/${API.faKey}/game-contest-leaderboard/`, params).then((resp) => {
      return resp.data.data
    })
  }
}
